import type { ErrorContext } from '@/libs/datadog';

/**
 * App identity reported to the Cookie Consent banner. Stays "Panorama" in every
 * environment so consent is not split by deployment.
 */
export const PANORAMA_APP_NAME = 'Panorama';

/** Visible product-name suffix for local development and the staging deployment. */
export const PANORAMA_DEV_NAME_SUFFIX = 'DEV';

/** Visible product-name suffix for the UAT deployment. */
export const PANORAMA_UAT_NAME_SUFFIX = 'UAT';

/** Vite mode for the local dev server. */
export const DEVELOPMENT_ENVIRONMENT = 'development';

/**
 * Vite mode for the staging deployment. It shares the Dev product name with
 * local development because both use the staging backend.
 */
export const STAGING_ENVIRONMENT = 'staging';

/** Vite mode for the UAT deployment. */
export const UAT_ENVIRONMENT = 'uat';

/** Production wordmark size from the home-logo design. */
export const PRODUCT_NAME_FONT_SIZE = '18px';

/** Dev and UAT wordmark size. Both are smaller than the production name. */
export const PRODUCT_NAME_ENVIRONMENT_FONT_SIZE = '12px';

export const PRODUCT_NAME_LINE_HEIGHT = '24px';

export const PRODUCT_NAME_LETTER_SPACING = '-0.135px';

export const PRODUCT_NAME_ENVIRONMENT_LETTER_SPACING = '-0.09px';

export const PRODUCT_NAME_REGULAR_WEIGHT = 400;

export const PRODUCT_NAME_BOLD_WEIGHT = 700;

/**
 * Root id rendered by the Cropwise topbar. The product name is a direct `h1`
 * child of that root, so host styles can reach it without a prop for color
 * or weight.
 */
export const TOPBAR_NAVIGATION_ID = 'topbar-navigation';

/**
 * Datadog context attached when the remote `topbar-navigation` micro-frontend
 * fails to load and the boundary degrades to <TopbarFallback/>. Keeps the
 * failure filterable/alertable in RUM by `feature`.
 */
export const TOPBAR_ERROR_CONTEXT: ErrorContext = {
  feature: 'topbar-navigation',
  degraded: true
};
